<template>
  <div class="clienttable">
    <el-table
      :data=clients
      empty-text="No Clients Found"
      style="width: 100%">
      <el-table-column
         label="Name"
         prop="name"
         header-align="center">
      </el-table-column>
      <el-table-column
         label="Address"
         prop="address"
         header-align="center">
        </el-table-column>
        <el-table-column
         label="Longitude"
         prop="longitude"
         header-align="center">
        </el-table-column>
        <el-table-column
         label="Latitude"
         prop="latitude"
         header-align="center">
        </el-table-column>
        <el-table-column
         label="Zoom"
         prop="zoom"
         header-align="center">
      </el-table-column>
      <el-table-column
         label="Sunset offset (minutes before)"
         prop="sunset_offset"
         header-align="center">
      </el-table-column>

      <el-table-column
        v-if="userIsSuperAdmin"
        label="Operations"
        header-align="center">
        <template slot-scope="props">
          <operations :id="props.row.id" 
            @view="viewSites" 
            @edit="editClient(props.row)" 
            @delete="deleteClient">
          </operations>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
  import auth from '../../../auth'
  import requests from '../../../requests';

  import operations from '../OpButtons.vue';

  export default {
    name: 'clienttable',
    data () {
      return {
        clients:[],
        userIsSuperAdmin: false,
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      var context = this;

      requests.getAllClients(this, function(result){
        if(result.action === 'success'){
          var clients = result.data;
          for(var i = 0; i < clients.length; i++){
            context.clients.push(clients[i]);
          }
        }
      });
    },
    methods: {
      viewSites(id) {
        this.$router.push({path:'/admin/clients/' + id});
      },
      editClient(id) {
        this.$emit('editClient', id);
      },
      deleteClient(id) {
        this.$emit('deleteClient', id);
      }
    },
    components: {
      'operations': operations
    }
  }
  

</script>

<style>

  .el-table .cell {
    word-break: normal !important;
  }

</style>




// WEBPACK FOOTER //
// ClientTable.vue?0d7a1ede